/**
 * Generate optimized image URL using Supabase Storage image transformation.
 * Only works for Supabase storage URLs.
 */
const SUPABASE_STORAGE_PREFIX = "supabase.co/storage/v1/object/public/";

function isSupabaseStorageUrl(url: string): boolean {
  return url.includes(SUPABASE_STORAGE_PREFIX);
}

export function getOptimizedImageUrl(url: string, width: number, quality = 60): string {
  if (!isSupabaseStorageUrl(url)) return url;
  // Use Supabase image transformation render endpoint (auto-negotiates WebP/AVIF via Accept).
  // Note: Supabase requires quality >= 20.
  const transformed = url.replace(
    "/storage/v1/object/public/",
    "/storage/v1/render/image/public/"
  );
  const q = Math.max(20, Math.min(100, Math.round(quality)));
  return `${transformed}?width=${width}&quality=${q}`;
}

export function generateSrcSet(
  url: string,
  widths: number[],
  quality = 60
): string {
  if (!isSupabaseStorageUrl(url)) return "";
  return widths
    .map((w) => `${getOptimizedImageUrl(url, w, quality)} ${w}w`)
    .join(", ");
}
